import { defineStore } from 'pinia';

export const useSearchMenuStore = defineStore('searchMenuStore', {
  state() {
    return {
      showSearchMenu: false,
      showVehicleSearch: false,
    };
  },
});
